// Region → Amazon store mapping (based on active app language + navigator.language)
const ASIN = "B0H2S1XFGM";

export function amazonBookUrl(lang) {
  const nav = typeof navigator !== "undefined" ? (navigator.language || "").toLowerCase() : "";
  if ((lang || "").startsWith("fr")) return `https://www.amazon.fr/dp/${ASIN}`;
  if (nav.includes("gb") || nav.includes("uk") || nav === "en-gb") return `https://www.amazon.co.uk/dp/${ASIN}`;
  if (nav.includes("ca")) return `https://www.amazon.ca/dp/${ASIN}`;
  if (nav.includes("au")) return `https://www.amazon.com.au/dp/${ASIN}`;
  if (nav.includes("de")) return `https://www.amazon.de/dp/${ASIN}`;
  if (nav.includes("es")) return `https://www.amazon.es/dp/${ASIN}`;
  if (nav.includes("it")) return `https://www.amazon.it/dp/${ASIN}`;
  if (nav.startsWith("fr")) return `https://www.amazon.fr/dp/${ASIN}`;
  return `https://www.amazon.com/dp/${ASIN}`;
}
